
























import { Component, Vue, Prop } from "vue-property-decorator";

import { Lotto } from "@/lotto";

@Component({
    name: "LotteryItem",
    props: {
        setCode: String,
        index: Number,
    },
})
export default class LotteryItem extends Vue {
    private final: boolean = false;
    private currentName: string = "";
    private created: number = 0;
    private spinTime: number = 0;
    private winner: string = "";
    private lastFrame: number = 0;

    private setCode: string | undefined;
    private index: number | undefined;

    public async mounted() {
        const lotto: Lotto = await this.$root.$data.lottery;
        const index = this.index === undefined ? 0 : this.index;
        this.created = performance.now();
        this.spinTime = this.$root.$data.lotteryTime * (index + 1);

        const winningTicket = lotto.sets.find((ticket) => ticket.set.code === this.setCode);

        if (winningTicket) {
            this.winner = winningTicket.set.name;
        } else {
            this.final = true;
            this.currentName = "UNKNOWN SET";
        }
        this.spin();
    }

    private async updateCurrentNameWithRandomSet() {
        const lotto: Lotto = await this.$root.$data.lottery;
        const set = lotto.getSet();

        this.currentName = set.name;
    }

    private spin() {
        this.updateSpin();
    }

    private updateSpin(): void {
        const thisFrameTime = performance.now();

        if (this.final) {
            return;
        }

        if (thisFrameTime >= this.created + this.spinTime) {
            this.currentName = this.winner;
            this.final = true;

            return;
        }

        if (thisFrameTime >= this.lastFrame + (1000 / Math.max(1, this.$root.$data.frameRate))) {
            this.updateCurrentNameWithRandomSet();
            this.lastFrame = thisFrameTime;
        }

        requestAnimationFrame(() => {
            this.updateSpin();
        });
    }
}
